import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {MedicationService} from '@services/medication.service';
import {MedicationUnitOptions} from '@/common/Enum/MedicationType.Enum';
@Component({
    selector: 'app-medication-detail',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './medication-detail.component.html',
    styleUrl: './medication-detail.component.scss'
})
export class MedicationDetailComponent implements OnInit {
    public medicationId: number;
    public medicationDetail: any;
    public medicationUnitOptions = MedicationUnitOptions;
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private medicationService: MedicationService
    ) {}

    ngOnInit(): void {
        this.medicationId = this.route.snapshot.params['id'];

        if (this.medicationId) {
            this.GetMedicationDetailInfoById(this.medicationId);
        }
    }

    GetMedicationDetailInfoById(MedicationId: any) {
        this.medicationService
            .getMedicationDetailInfoById(MedicationId)
            .subscribe((response: any) => {
                this.medicationDetail = response;
            });
    }

    getMedicationUnitLabel(value: number): string {
        const match = this.medicationUnitOptions.find(
            (unit) => unit.value === value
        );
        return match ? match.label : 'Unknown';
    }
}
